import { IControlHandler, createControlHandler, registerControlHandler } from '@ms/items-view/lib/private/addons/registerControlHandler';
import { itemEngagementControl } from '@ms/items-view/lib/private/controls/itemEngagementControl';
import { spItemKeyFacet, spListKeyFacet } from '../../../dataSource/Keys';
import { IItemCacheThunkAction, IItemCacheDispatch } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { IItemCache } from '@ms/items-view/lib/private/models/IItemCacheObserver';
import { uniqueIdFacet, listFacet } from '../../../dataSource/Facets';
import PageContextEngagementHandler from '@ms/odsp-datasources/lib/dataSources/engagement/handlers/PageContextEngagementHandler';
import { getPageContextFromItemCache } from '../../../utilities/item/pageContextHelper';

import {
  createAddon,
  IAddon
} from '@ms/items-view/lib/private/addons/registerOperationHandler';

const spItemEngagementControlHandler: IControlHandler<typeof spItemKeyFacet.type, typeof itemEngagementControl.type> =
  createControlHandler()(getControlHandler);

function getControlHandler(): IItemCacheThunkAction<typeof itemEngagementControl.type> {
  return (dispatch: IItemCacheDispatch) => {
    return (
      itemCache: IItemCache,
      props: typeof itemEngagementControl.inputType
    ): typeof itemEngagementControl.returnType => {
      const {
        itemKey
      } = props;

      // Should only demand uniqueIdFacet when it is resolved to avoid auto-trigger a single item fetch.
      const uniqueId = itemCache.isItemFacetResolved(uniqueIdFacet, itemKey) ?
        itemCache.demandItemFacet(uniqueIdFacet, itemKey) : undefined;

      const pageContext = getPageContextFromItemCache(itemCache, itemKey);

      const spItem = itemCache.demandItemFacet(spItemKeyFacet, itemKey);

      let pageContextEngagement: (typeof itemEngagementControl.returnType)['engagement'];

      if (pageContext) {
        const pageContextEngagementHandler = new PageContextEngagementHandler({}, {
          pageContext
        });

        pageContextEngagement = pageContextEngagementHandler.getEngagementData();
      }

      const spListKey = spItem && spListKeyFacet.serialize(spItem);
      const list = itemCache.demandItemFacet(listFacet, spListKey);

      return {
        engagement: {
          datasource: 'SharePoint',
          ...(pageContextEngagement || {}),
          ...(uniqueId ? {
            docId: uniqueId,
          } : {}),
          ...(list ? {
            listId: list.id,
            listTemplateId: `${list.templateType}`,
            extraData: {
              createdFromExcel: list.createdFromExcel,
              createdFromExisting: list.createdFromExisting
            }
          } : {})
        }
      };
    };
  };
}

export const getSPItemEngagementAddon: IAddon = createAddon(() => {
  return async (dispatch: IItemCacheDispatch) => {
    dispatch(registerControlHandler(spItemKeyFacet, itemEngagementControl)(
      spItemEngagementControlHandler
    ));
  };
});
